import { GetterTree } from 'vuex';
import { GlobalState } from '../types';
import { AuthState } from './types';

export const getters: GetterTree<AuthState, GlobalState> = {
    isAuthenticated: (state) => Boolean(
        state.session &&
        state.session.accessToken &&
        state.session.accessToken.jwtToken
    ),

    accessToken: (state) => {
        if (state.session &&
            state.session.accessToken &&
            state.session.accessToken.jwtToken)
        {
            return state.session.accessToken.jwtToken;
        } else {
            return "";
        }
    },

    isAdmin: (state) => Boolean(
        state.session &&
        state.session.accessToken &&
        state.session.accessToken.payload &&
        state.session.accessToken.payload['cognito:groups'] &&
        state.session.accessToken.payload['cognito:groups'].indexOf('admin') >= 0
    )
};
